import React, { useEffect, useRef, useState } from "react";
import style from "./HeldWorkflowMenu.module.scss";
import workflowTemplateStyles from "../../templates/flowbots/WorkflowTemplate.module.scss";
import { Loader } from "../Loaders/Loader";
import { NoticeMessage } from "../../templates/flowbots/Notice/NoticeMessage";
import axios from "axios";
import useLanguageChange from "../../../hooks/useLanguageChange";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

type Props = {
  contentableType: string;
  projectNames: Array<[string, number]>;
  sectionId: number;
  totalCount: number;
  clientCode: string;
  locale: string;
};

export const HeldWorkflowMenu = (props: Props) => {
  const { t } = useLanguageChange(props.locale);
  const detailMenuRef = useRef<HTMLDivElement>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [notice, setNotice] = useState({ isShow: false, message: "", type: "" });
  const [isShowDetailMenu, setIsShowDetailMenu] = useState(false);

  const handleClickOutsideDetailMenu = (event: MouseEvent) => {
    if (detailMenuRef.current && !detailMenuRef.current.contains(event.target as Node)) {
      setIsShowDetailMenu(false);
    }
  };

  const handleLaunchHeldWorkflow = async () => {
    const confirmMessage = t("HeldWorkflowMenu.保留中の全てのフローボットを起動しますか？(最大200件）");
    if (window.confirm(confirmMessage)) {
      setIsLoading(true);
      await axios
        .post(`/${props.clientCode}/workflows/boot_held_workflows`, {
          ids: [],
          is_bulk: true,
          section_id: props.sectionId,
        })
        .then((res) => {
          if (res.status === 200) {
            // NOTE: ローカルストレージにres.data.messageを保存し、リロード後に表示している
            localStorage.setItem("workflow_template_notice", res.data.message);
            window.location.href = res.data.redirect_url;
          }
        })
        .catch((error) => {
          if (error.response.status === 400) {
            setIsLoading(false);
            setNotice({ isShow: true, message: error.response.data.message, type: "error" });
          } else {
            setIsLoading(false);
            setNotice({ isShow: true, message: t("HeldWorkflowMenu.フローボットの起動に失敗しました"), type: "error" });
          }
        });
    }
  };

  const handleTerminateHeldWorkflow = async () => {
    const confirmMessage = t("HeldWorkflowMenu.保留中の全てのフローボットを停止しますか？");
    if (window.confirm(confirmMessage)) {
      setIsLoading(true);
      await axios
        .post(`/${props.clientCode}/workflows/destroy_held_workflows`, {
          ids: [],
          is_bulk: true,
          section_id: props.sectionId,
        })
        .then((res) => {
          if (res.status === 200) {
            // NOTE: ローカルストレージにres.data.messageを保存し、リロード後に表示している
            localStorage.setItem("workflow_template_notice", res.data.message);
            location.reload();
          }
        })
        .catch((error) => {
          if (error.response.status === 400) {
            setIsLoading(false);
            setNotice({ isShow: true, message: error.response.data.message, type: "error" });
          } else {
            setIsLoading(false);
            setNotice({ isShow: true, message: t("HeldWorkflowMenu.フローボットの停止に失敗しました"), type: "error" });
          }
        });
    }
  };

  useEffect(() => {
    // ローカルストレージにworkflow_template_noticeがあれば、その内容を取得して表示
    const noticeMessage = localStorage.getItem("workflow_template_notice");
    if (noticeMessage) {
      setNotice({ isShow: true, message: noticeMessage, type: "notice" });
      localStorage.removeItem("workflow_template_notice");
    }
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideDetailMenu);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideDetailMenu);
    };
  }, [handleClickOutsideDetailMenu]);

  return (
    <>
      <div className={style.detailMenu} onClick={() => setIsShowDetailMenu(!isShowDetailMenu)} ref={detailMenuRef}>
        ･･･
        {isShowDetailMenu && (
          <div className={style.detailPopup}>
            <div className={style.normalText} onClick={handleLaunchHeldWorkflow}>
              {t("HeldWorkflowMenu.保留中の全てを起動（最大200件）")}
            </div>
            <div
              className={style.redText}
              onClick={handleTerminateHeldWorkflow}
              data-testid="workflow-template-terminate"
            >
              {t("HeldWorkflowMenu.保留中の全てを停止")}
            </div>
          </div>
        )}
      </div>
      <NoticeMessage notice={notice} setNotice={setNotice} />
      {isLoading && (
        <div className={workflowTemplateStyles.loaderWrapper}>
          <div className={workflowTemplateStyles.loaderContent}>
            <Loader loaderColor="yoom-green" loaderSize={35} />
          </div>
        </div>
      )}
      <NoticeMessage notice={notice} setNotice={setNotice} />
    </>
  );
};
